import { BackButton } from 'atoms/BackButton';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { AppFooter } from 'templates/AppFooter';

import { PageContent } from 'templates/PageContent';
import { UnauthHeader } from 'templates/UnauthHeader';

export function AboutMfaCodeSending() {
  const { t: tAboutMfaCodeSending } = useTranslationWithLang('aboutMfaCodeSending');
  console.log(tAboutMfaCodeSending);
  return (
    <>
      <div className="h-full" style={{ background: 'var(--c-background)' }}>
        <UnauthHeader />
        <div role="heading" aria-level={1} aria-live="assertive" className="sr-only">
          {tAboutMfaCodeSending('TU000_001')}
        </div>
        <PageContent>
          <h1 className="text-[--c-text2] font-bold text-2xl mb-8 underline">
            {tAboutMfaCodeSending('TU000_001')}
          </h1>

          <h2 className="font-semibold">・{tAboutMfaCodeSending('TU000_002')}</h2>
          <p className="ml-5 whitespace-pre-wrap">{tAboutMfaCodeSending('TU000_003')}</p>

          <h2 className="font-semibold mt-5">・{tAboutMfaCodeSending('TU000_004')}</h2>
          <p className="ml-5 mb-2">{tAboutMfaCodeSending('TU000_005')}</p>
          <ul className="ml-5 mb-4">
            <p className="mb-2 whitespace-pre-wrap">{tAboutMfaCodeSending('TU000_006')}</p>
            <p className="mb-2 whitespace-pre-wrap">{tAboutMfaCodeSending('TU000_007')}</p>
            <p className="mb-2 whitespace-pre-wrap">{tAboutMfaCodeSending('TU000_008')}</p>
            <p className="mb-2 whitespace-pre-wrap">{tAboutMfaCodeSending('TU000_009')}</p>
            <p className="mb-2 whitespace-pre-wrap">{tAboutMfaCodeSending('TU000_010')}</p>
          </ul>

          <h2 className="font-semibold mt-5">・{tAboutMfaCodeSending('TU000_011')}</h2>
          <p className="ml-5">{tAboutMfaCodeSending('TU000_012')}</p>
          <p className="ml-5 whitespace-pre-wrap">{tAboutMfaCodeSending('TU000_013')}</p>
          <div className="flex justify-center">
            <BackButton />
          </div>
        </PageContent>
        <AppFooter />
      </div>
    </>
  );
}
